// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.sanction-notification[data-v-84fe8198] {\n  max-width: 550px;\n  text-align: center;\n  margin: auto;\n}\n.card-width[data-v-84fe8198] {\n  width: 380px;\n  margin: 20px auto 0;\n}\n.display-column[data-v-84fe8198] {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-size: 16px;\n}\n.margin-bottom-48[data-v-84fe8198] {\n  margin-bottom: 48px;\n}\n", ""]);
// Exports
module.exports = exports;
